import { Swiper, Navigation, Pagination, Thumbs } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Thumbs]);

export default () => {
    var swiper = new Swiper('.gallery-modal-slider', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: '.banner-button-next',
            prevEl: '.banner-button-prev',
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    var photosThumb = new Swiper(".gallery__thumbs", {
      spaceBetween: 10,
      slidesPerView: 6,
      freeMode: true,
      thumbsContainerClass: ".swiper-thumbs",
      slideThumbActiveClass: "swiper-slide-thumb-active",
      watchSlidesProgress: true,
      breakpoints: {
        600: {
          slidesPerView: 3,
        },
      }
    });

    var photos = new Swiper(".gallery__slider", {
      spaceBetween: 10,
      navigation: {
        nextEl: ".gallery-button-next",
        prevEl: ".gallery-button-prev",
      },
      thumbs: {
        swiper: photosThumb,
      },
    });

    // componente de banner padrão
    let bannerBlog = new Swiper(".banner__blog", {
        watchOverflow: true,
        pagination: {
            el: ".banner-blog",
            type: "bullets",
            clickable: true,
        },
    });
};
